// extracted by mini-css-extract-plugin
export default {"CustomerInfoTab":"CustomerInfoTab_CustomerInfoTab__vW8kd","required":"CustomerInfoTab_required__echke","dropdownmargin":"CustomerInfoTab_dropdownmargin__fxr8C"};